"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("../../../../../../Icon"));
var Price_1 = __importDefault(require("../../../../../../Price"));
var AmenityList_1 = __importDefault(require("../../../../../AmenityList"));
var MortgageItemRow_1 = __importDefault(require("./MortgageItemRow"));
var PostViewContentTypes_1 = require("../../../../../../../constants/PostViewContentTypes");
var SpecialMortgageRow_1 = __importDefault(require("./SpecialMortgageRow"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../../../../../../features/languages/languageSlice");
var ViewDeveloperInfoSection_1 = __importDefault(require("./ViewDeveloperInfoSection"));
var deviceHelper_1 = require("../../../../../../../helpers/deviceHelper");
var MonthlyMortgagePerApt_1 = __importDefault(require("./MonthlyMortgagePerApt"));
var PostViewSelectOptions_1 = require("../../../../../../../constants/PostViewSelectOptions");
var AnimalsRow_1 = __importDefault(require("./AnimalsRow"));
var translationHelper_1 = require("../../../../../../../helpers/translationHelper");
var style_module_scss_1 = __importDefault(require("../../style.module.scss"));
var ApartmentTableRow = function (_a) {
    var _b, _c;
    var data = _a.data, isExpanded = _a.isExpanded, onToggleCollapsible = _a.onToggleCollapsible, postData = _a.postData, redirectToMortgageSection = _a.redirectToMortgageSection, setPostMedia = _a.setPostMedia, handleScrollToShowMobileMedias = _a.handleScrollToShowMobileMedias, isRent = _a.isRent;
    var sub_building = data.sub_building, apt_number = data.apt_number, rooms = data.rooms, area = data.area, price = data.price, currency = data.currency, floor = data.floor, availability = data.availability, description = data.description, _d = data.description_en, description_en = _d === void 0 ? '' : _d, _e = data.description_ru, description_ru = _e === void 0 ? '' : _e, amenities = data.amenities, entity_id = data.entity_id, apartment_plan = data.apartment_plan, floor_plan = data.floor_plan, building_plan = data.building_plan, media = data.media, animals = data.animals;
    var t = react_i18next_1.useTranslation('common').t;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var apartmentDescription = translationHelper_1.getDescription(currentLanguage, description, description_ru, description_en);
    var selectedBankData = react_1.useMemo(function () {
        var isExclusive = postData.sections.mortgage.some(function (item) { return item.is_exclusive === 'is_available'; });
        if (isExclusive) {
            return postData.sections.mortgage.filter(function (item) { return item.is_exclusive === 'is_available'; })[0];
        }
        else {
            return PostViewSelectOptions_1.DefaultBank;
        }
    }, [postData.sections.mortgage]);
    var handleSelectApartmentItem = function () {
        redirectToMortgageSection({
            price: [{ price: data.price, currency: currency }],
            apt_number: data.apt_number,
            sub_building: data.sub_building,
        });
    };
    var onToggleCLick = function (id) {
        onToggleCollapsible(id);
        var postMedia = __spreadArray([], media);
        apartment_plan && postMedia.push(apartment_plan);
        floor_plan && postMedia.push(floor_plan);
        building_plan && postMedia.push(building_plan);
        setPostMedia(postMedia);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(semantic_ui_react_1.Table.Row, { className: classnames_1.default(style_module_scss_1.default.table_row, (_b = {},
                _b[style_module_scss_1.default.row_expanded] = isExpanded,
                _b)), onClick: function () { return onToggleCLick(entity_id); } },
            react_1.default.createElement(semantic_ui_react_1.Table.Cell, { className: style_module_scss_1.default[availability] }, sub_building + "-" + apt_number),
            react_1.default.createElement(semantic_ui_react_1.Table.Cell, null, rooms === '-1' ? t('POST_CARD.FREE_LAYOUT_DESIGN') : rooms),
            react_1.default.createElement(semantic_ui_react_1.Table.Cell, null, "" + area + t('FIELD_OPTIONS.sq_meter')),
            react_1.default.createElement(semantic_ui_react_1.Table.Cell, null,
                react_1.default.createElement(Price_1.default, { value: [{ price: price, currency: currency }], defaultValue: "", className: style_module_scss_1.default.price + " " + style_module_scss_1.default.price_table })),
            react_1.default.createElement(semantic_ui_react_1.Table.Cell, null, floor),
            react_1.default.createElement(semantic_ui_react_1.Table.Cell, { collapsing: true, textAlign: "right", className: style_module_scss_1.default.expandable, onClick: function () { return onToggleCLick(entity_id); } },
                react_1.default.createElement(Icon_1.default, { semanticName: isExpanded ? 'angle up' : 'angle down' }))),
        isExpanded && (react_1.default.createElement(semantic_ui_react_1.Table.Row, { className: classnames_1.default((_c = {}, _c[style_module_scss_1.default.row_expanded] = isExpanded, _c)) },
            react_1.default.createElement(semantic_ui_react_1.Table.Cell, { colSpan: "6" },
                react_1.default.createElement("div", null,
                    deviceHelper_1.isMobile() && (react_1.default.createElement(ViewDeveloperInfoSection_1.default, { handleScrollToShowMobileMedias: handleScrollToShowMobileMedias })),
                    availability === PostViewContentTypes_1.POST_AVAILABILITY.SALE &&
                        !isRent && (react_1.default.createElement(MortgageItemRow_1.default, { price: price, region: postData.addressData.state, district: postData.addressData.district, address: postData.addressData.address, currency: currency, handleSelectApartmentItem: handleSelectApartmentItem })),
                    postData.sections.mortgage.length && (react_1.default.createElement(SpecialMortgageRow_1.default, { mortgage: postData.sections.mortgage })),
                    postData &&
                        'name' in postData.sections.mortgage[0] && (react_1.default.createElement(MonthlyMortgagePerApt_1.default, { price: [{ price: price, currency: currency }], max_duration: selectedBankData.max_duration, min_percent: selectedBankData.min_percent, min_prepayment: selectedBankData.min_prepayment })),
                    amenities && react_1.default.createElement(AmenityList_1.default, { amenities: amenities }),
                    !!(animals === null || animals === void 0 ? void 0 : animals.length) && (react_1.default.createElement(AnimalsRow_1.default, { animals: animals })),
                    apartmentDescription && (react_1.default.createElement("div", { className: classnames_1.default('text', style_module_scss_1.default.description), dangerouslySetInnerHTML: {
                            __html: apartmentDescription,
                        } }))))))));
};
exports.default = ApartmentTableRow;
